// ----------------------------------------------------------------------
// <copyright file="Izenda.ScheduleContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ScheduleContainer component
 */
!(function () {

  var React = require('react');  
  var ScheduleHeader = require('./Izenda.ScheduleHeader');
  var ScheduleBody = require('./Izenda.ScheduleBody');
  var connect = require('share/enhancers/Izenda.Connect');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');

  var ScheduleContainer = connect()(function (props) {
    return (
      <div className="izenda-Wrapper-content">
        <ScrollBox>
          <div className="u_fullHeight u_paddingLeftRight">
            <ScheduleHeader {...props}></ScheduleHeader>
            <ScheduleBody {...props}></ScheduleBody>
          </div>
        </ScrollBox>
      </div>
    );
  });

  ScheduleContainer.propTypes = {
    store: React.PropTypes.object.isRequired,
    subscribedInstancesStore: React.PropTypes.object.isRequired
  }

  module.exports = ScheduleContainer;
}());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Schedule/Izenda.ScheduleContainer.jsx